import React from "react";
import { FormHelperText, InputAdornment } from "@material-ui/core";

import { approvalStatuses } from "../../../../types/approval-status/approval-statuses.constant";
import { CampaignBriefTemplateLabels } from "../../../../types/templates/campaign-brief/campaign-brief-template-labels.constant";
import { CheckboxField } from "../../../../features/forms/fields/checkbox-field/checkbox-field.component";
import { IUser } from "../../../../types/user/iuser.interface";
import { IRegionResults } from "../../../../types/search/iregion-results.interface";

import { Autocomplete } from "../../inputs/autocomplete/autocomplete.component";
import { Datepicker } from "../../inputs/date-picker/date-picker.component";
import { matchById, matchByValue } from "../../inputs/autocomplete/autocomplete.functions";

import { FiltersProps } from "../filters.props";
import { useFiltersStyles } from "../filters.styles";

export const CampaignBriefFilterFields = (props: FiltersProps) => {
  const classes = useFiltersStyles();

  return (
    <>
      <Autocomplete
        control={props.control}
        label="Brief owner"
        limitTags={2}
        name="briefOwner"
        optionLabel={(user: IUser) => `${user.firstName} ${user.lastName}`}
        optionSelected={matchById}
        options={props.optionLists.users!}
      />
      <Autocomplete
        control={props.control}
        label="Template"
        limitTags={2}
        name="template"
        optionSelected={matchByValue}
        options={CampaignBriefTemplateLabels}
      />
      <div className={classes.dateRange}>
        <Datepicker
          control={props.control}
          error={!!props.errors?.dateTo}
          label="Start Date"
          name="dateFrom"
        />
        <span>to</span>
        <Datepicker
          control={props.control}
          error={!!props.errors?.dateTo}
          label="End Date"
          name="dateTo"
        />
      </div>
      {props.errors?.dateTo && (
        <FormHelperText className={classes.error} error={true}>
          {props.errors.dateTo.message}
        </FormHelperText>
      )}
      <Autocomplete
        control={props.control}
        label="Region"
        limitTags={2}
        multiple={true}
        name="regions"
        optionLabel={(region: IRegionResults) => region?.name}
        optionSelected={matchById}
        options={props.optionLists.regions!}
      />
      <Autocomplete
        control={props.control}
        label="Status"
        limitTags={2}
        name="status"
        optionSelected={matchByValue}
        options={approvalStatuses}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <CheckboxField form={props.form} label="Not: " name="statusInverted" noAuthRequired />
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};
